export default "__VITE_ASSET__D8S4NLkl__"